module.exports = __webpack_public_path__ + "static/img/loginBg.90d9243.png";


//////////////////
// WEBPACK FOOTER
// ./img/loginBg.png
// module id = NNeR
// module chunks = 1